class AdpTogglerController {
  constructor() {

    this.name = 'adpToggler';
    this.togglerOpened = false;
  }
  toggle() {
    this.togglerOpened = !this.togglerOpened;
  }
}

export default AdpTogglerController;



// WEBPACK FOOTER //
// ./src/app/components/adpToggler/adpToggler.controller.js